var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "26BC785C-FB10-42FC-97EB-2758593B6A13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-PROPOSAL-00",
    transform: "translate(-490.000000, -114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(490.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#295299",
    points: "4.0003 13 10.0003 13 10.0003 7 14.0003 7 7.0003 0 0.0003 7 4.0003 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#EC6524",
    points: "0 17 14 17 14 15 0 15"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImport);
export default __webpack_public_path__ + "static/media/ic_import.98acfe50d736df4e79bbf8c552c6db94.svg";
export { ForwardRef as ReactComponent };